import { createHostModule } from '@wix/sdk-runtime/host-modules';
export const lightboxRuntime = createHostModule({
    close: ({ channel }) => function close(...args) {
        return channel.invoke({
            namespace: 'window',
            method: 'lightbox.close',
            args,
        });
    },
    getContext: ({ channel }) => function getContext(...args) {
        return channel.invoke({
            namespace: 'window',
            method: 'lightbox.getContext',
            args,
        });
    },
    open: ({ channel }) => function open(...args) {
        return channel.invoke({
            namespace: 'window',
            method: 'lightbox.open',
            args,
        });
    },
});
//# sourceMappingURL=lightbox.runtime.js.map